@if (patient) {
  <app-traitement-data-mode [patient]="patient!" />
  @if (patient.tableauDeBord?.mode?.value == "PEP FIXE") {
    <app-traitement-data-epap [patient]="patient!" />
  } @else {
    <app-traitement-data-epap-min-max [patient]="patient!" />
  }
  <app-traitement-data-epap-95 [patient]="patient!" />
  <app-traitement-data-ai-min-max [patient]="patient!" />
  <app-traitement-data-obs [patient]="patient!" />
  <app-traitement-data-fuites [patient]="patient!" />
  <app-traitement-data-fuites-95 [patient]="patient!" />
  <app-traitement-data-ipap-95 [patient]="patient!" />
} @else {
  <app-traitement-data></app-traitement-data>
  <app-traitement-data></app-traitement-data>
  <app-traitement-data></app-traitement-data>
  <app-traitement-data></app-traitement-data>
  <app-traitement-data></app-traitement-data>
  <app-traitement-data></app-traitement-data>
  <app-traitement-data></app-traitement-data>
  <app-traitement-data></app-traitement-data>
}
